<template>
    <div>
        <a class="VueTables__primary-content" v-if="noAccessSubclient" :href="subclientUrl">{{ data.name }}</a>
        <div class="VueTables__primary-content" v-else>
            <a v-if="subclientIsAccessable" :href="subclientUrl">{{ data.name }}</a>
            <div v-else>{{ data.name }}</div>
        </div>
        <div class="VueTables__secondary-content">{{ data.city }}</div>
    </div>
</template>

<script>
    export default {
        props: ['data', 'index', 'column'],

        computed: {
            subclientUrl() {
                return `/clients/${this.data.id}`;
            },

            noAccessSubclient() {
                return typeof this.data.access_subclient == 'undefined'
            },

            subclientIsAccessable() {
                if (!this.noAccessSubclient) {
                    return this.data.access_subclient
                }
            }
        }
    }
</script>
